<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'evaluation/index' }">
                                Laporan Pengajar
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ evaluation.topic }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-md-8 col-12 mt-3">
                <form v-on:submit.prevent="save" disabled>
                    <div class="card shadow-sm mb-4 border-0">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                        Rekap Harian Pengajar BTA Group
                                    </span>
                                </div>
                                <div class="col-auto" v-if="roleElligibleModified()">
                                    <div class="edit-action">
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="toggleInput">
                                            Edit
                                        </button>
                                        <button type="button" class="btn btn-link h4 p-0 my-0" v-on:click="modalShow = true">
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body px-5 py-4">
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Tanggal</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="$moment(evaluation.session.date, 'YYYY-MM-DD').format('dddd, D MMMM YYYY')" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Lokasi BTA</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="evaluation.session.branchClass.pattern.branchProgram.branch.name" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Kelas BTA</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="evaluation.session.branchClass.name" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Mata Pelajaran</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="evaluation.session.subject.name" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Nama Pengajar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm" disabled v-bind:value="evaluation.session.teacher.employee.user.name" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider required">Bab</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.topic" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" required />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Sub Bab</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.subtopic" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Jumlah Soal yang Dibahas</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <input v-model="form.question" type="number" disabled class="form-control-plaintext toggle-input h4 mb-0 font-weight-medium form-control-sm" />
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center" v-if="roleElligibleView()">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted h4 mb-0 form-divider">Permasalahan Pengajar</label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <template v-if="roleElligibleModified()">
                                        <div class="wrapper-input">
                                            <div class="form-check py-1 pl-1" v-for="(problem, index) in problems">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.problem" type="radio" class="custom-control-input" v-bind:value="problem" v-bind:id="'input-problem-' + index" />
                                                    <label class="custom-control-label" v-bind:for="'input-problem-' + index">{{ problem }}</label>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-auto pr-1">
                                                    <div class="form-check py-1 pl-1">
                                                        <div class="custom-control custom-radio">
                                                            <input v-model="form.problem" type="radio" value="" class="custom-control-input" id="input-problem-other" />
                                                            <label class="custom-control-label" for="input-problem-other">Lainnya</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col pl-1">
                                                    <input v-model="form.otherProblem" v-bind:disabled="form.problem !== '' && form.problem !== null" class="form-control h4 mb-0 font-weight-medium form-control-sm"  />
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                    <input v-bind:value="evaluation.problem" disabled class="form-control-plaintext h4 mb-0 font-weight-medium form-control-sm toggle-input" />
                                </div>
                            </div>
                            <div class="my-4 text-center input-action">
                                <button type="submit" class="btn btn-danger btn-sm px-5 mx-2 mb-2">
                                    Save
                                </button>
                                <button v-on:click="toggleInput" type="button" class="btn btn-outline-danger btn-sm px-5 mx-2 mb-2">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <b-modal v-if="roleElligibleModified()" v-model="modalShow" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
            <template slot="modal-header">
                <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                    Warning!!
                </h4>
            </template>
            <div class="container text-center">
                <div class="row">
                    <div class="col-12">
                        <h4 class="font-weight-medium mb-4">Apa yakin mau menghapus laporan pengajar ini? Karena jika sudah terhapus data tidak dapat dikembalikan</h4>
                    </div>
                    <div class="col-12">
                        <button class="btn btn-outline-danger btn-sm px-5" v-on:click="remove">
                            Ya
                        </button>
                        <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modalShow = false">
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    /**
     * @param {Object} tryout
     */
    export default {
        name: "EvaluationView",
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    topic: '',
                    subtopic: '',
                    question: '',
                    problem: '',
                    otherProblem: ''
                },
                evaluation: {session: {teacher: {employee: {user: {}}}, branchClass: {pattern: {branchProgram: {branch: {}, grade: {}}}}, subject: {}}},
                problems: ['Terlambat', 'Komplain Siswa'],
                modalShow: false
            };
        },
        methods: {
            remove() {
                this.axios.post(process.env.API_URL + '/evaluation/delete/' + this.evaluation.id).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'evaluation/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            save(event) {
                if (this.form.problem === '' || this.form.problem === null) {
                    if (this.form.otherProblem !== '' || this.form.otherProblem !== null) {
                        this.form.problem = this.form.otherProblem;
                    } else {
                        this.form.problem = '';
                    }
                }
                this.axios.post(process.env.API_URL + '/evaluation/update/' + this.evaluation.id, Object.assign({}, this.form, {sessionID: this.evaluation.sessionID})).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.toggleInput(event);
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            toggleInput(event) {
                var form = event.currentTarget ? event.currentTarget.form : event.target;
                var editMode = form.hasAttribute('disabled');
                if (editMode) {
                    var forms = document.querySelectorAll('form:not([disabled])');
                    for (var i = 0; i < forms.length; i++) {
                        this.formState(forms[i], false);
                    }
                    if (forms.length) {
                        this.fetchEvaluation();
                    }
                } else {
                    this.fetchEvaluation();
                }
                this.formState(form, editMode);
            },
            formState(form, editMode) {
                if (editMode) {
                    form.removeAttribute('disabled');
                } else {
                    form.setAttribute('disabled', 'disabled');
                }
                var inputs = form.getElementsByClassName('toggle-input');
                for (var i = 0; i < inputs.length; i++) {
                    var input = inputs[i];
                    if (editMode) {
                        input.classList.add('form-control');
                        input.classList.remove('form-control-plaintext');
                        input.removeAttribute("disabled");
                    } else {
                        input.classList.add('form-control-plaintext');
                        input.classList.remove('form-control');
                        input.setAttribute('disabled', 'disabled');
                    }
                }
            },
            fetchEvaluation() {
                this.axios.get(process.env.API_URL + '/evaluation/' + this.$route.params.id).then(response => {
                    this.evaluation = response.data.data;
                    this.form = Object.assign({}, this.evaluation);
                    let hasProblemRecommendation = this.problems.find(problem => problem === this.form.problem);
                    if (!hasProblemRecommendation) {
                        this.form.otherProblem = this.form.problem;
                        this.form.problem = '';
                    } else {
                        this.form.otherProblem = '';
                    }

                    document.title = 'Prodi ' + this.evaluation.topic + ' - ' + process.env.APP_NAME;
                });
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isMentor || this.profile.employee.isBranchStaff));
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isMentor || this.profile.employee.isBranchStaff));
            }
        },
        created() {
            this.fetchEvaluation();
        }
    };
</script>

<style scoped>
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    form .edit-action, form[disabled] .input-action { display: none; }
    form .input-action, form[disabled] .edit-action { display: block; }

    form[disabled] select.form-control-plaintext { -moz-appearance: none; -webkit-appearance: none; appearance: none; }
    form:not([disabled]) .wrapper-input + .toggle-input, form[disabled] .wrapper-input { display: none; }
</style>


// WEBPACK FOOTER //
// src/components/evaluation/View.vue